module.exports = __webpack_public_path__ + "media/beep-sad.bc3fcce4.wav";